var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Env from '../../env';
import { support, handle } from '../../core';
import { compareVersion, onceIn, registerJsHandler } from '../../utils';
var noop = function () {
    return;
};
/* eslint-disable */
/**
 * 新增js bridge 接口在export中增加配置项即可。
 * 调用方法如：dbridge.xxx，其中xxx为方法列表的key
 * 配置项包括：
 * name：FE与native RD协商的接口名称。若无name项，则默认为列表key
 * alias：接口别名，多个别名用"|"分隔，每个别名也可以用dbridge.xxx形式调用。别名调用方式是为了向前兼容，不推荐此种调用方式
 * support：native从哪个版本开始支持该接口，值为字符串或者数组
 *   如：'2.4.4'即表示iOS APP和android APP均从2.4.4版本开始支持；
 *   [{type: 'android', version: '2.4.4'}]表示android APP从2.4.4支持，iOS不支持。
 *   prepare：自定义处理函数，主要用于抹平iOS和Android司机端实现差异，接受两个可选参数，返回结果为数组，格式如[String fnName, JSON params, function cb]，
 **/
var config = {
    shareWeixinAppmsg: {
        alias: 'weixinAppmsg|shareWeixinAppmsg|share_weixin_appmsg|weixin_appmsg',
        support: '2.4.4',
        prepare: function (params) {
            var conf = {
                url: params.url || params.share_url,
                icon: params.icon ||
                    params.icon_url ||
                    params.share_icon_url ||
                    params.imageUrl ||
                    params.share_img_url,
                title: params.title || params.share_title,
                desc: params.desc ||
                    params.content ||
                    params.share_content ||
                    params.descript
            };
            var cfg;
            if (Env.isIOSApp) {
                cfg = {
                    share_url: conf.url,
                    share_icon_url: conf.icon,
                    share_title: conf.title,
                    share_content: conf.desc
                };
                return ['share_weixin_appmsg', JSON.stringify(cfg), noop];
            }
            else if (Env.isAndroidApp) {
                cfg = {
                    url: conf.url,
                    imageUrl: conf.icon,
                    title: conf.title,
                    descript: conf.desc,
                    isFriendCircle: false
                };
                return ['callWXShare', cfg, noop];
            }
        }
    },
    shareDidiTribe: {
        alias: 'shareDidiTribe',
        support: '2.4.4',
        prepare: function (params, cb) {
            var cfg = {
                url: params.url,
                icon: params.icon,
                title: params.title,
                desc: params.content || params.desc
            };
            return ['shareDidiTribe', cfg, noop];
        }
    },
    shareWeixinTimeline: {
        alias: 'weixinTimeline|shareWeixinTimeline|share_weixin_timeline|weixin_timeline',
        support: '2.4.4',
        prepare: function (params) {
            var conf = {
                url: params.url || params.share_url,
                icon: params.icon ||
                    params.icon_url ||
                    params.share_icon_url ||
                    params.imageUrl,
                title: params.title || params.share_title,
                desc: params.desc ||
                    params.content ||
                    params.share_content ||
                    params.descript
            };
            var cfg;
            if (Env.isIOSApp) {
                cfg = {
                    share_url: conf.url,
                    share_icon_url: conf.icon,
                    share_title: conf.title,
                    share_content: conf.desc
                };
                return ['share_weixin_timeline', JSON.stringify(cfg), noop];
            }
            else if (Env.isAndroidApp) {
                cfg = {
                    url: conf.url,
                    imageUrl: conf.icon,
                    title: conf.title,
                    descript: conf.desc,
                    isFriendCircle: true
                };
                return ['callWXShare', cfg, noop];
            }
        }
    },
    shareSMS: {
        alias: 'share_sms|shareSms',
        support: '2.4.4',
        prepare: function (params, cb) {
            return ['share_sms', params, cb];
        }
    },
    launchScan: {
        support: '5.0.18',
        prepare: function (params, cb) {
            var fn = function (result) {
                var ret = typeof result === 'string' ? JSON.parse(result) : result;
                cb(ret);
            };
            return ['launchScan', params, fn];
        }
    },
    scanQrCode: {
        support: '5.1.40',
        prepare: function (params, cb) {
            var fn = function (result) {
                var ret = typeof result === 'string' ? JSON.parse(result) : result;
                cb(ret);
            };
            return ['scanQrCode', params, fn];
        }
    },
    initEntrance: {
        alias: 'init_entrance',
        support: '2.4.4',
        prepare: function (params, cb) {
            if (!params.buttons) {
                console.info('bridge warn: use buttons list instead of single object for initEntrance ,see http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=116169534');
            }
            return ['init_entrance', params, cb];
        }
    },
    invokeEntrance: {
        alias: 'share_slide_up|shareSlideUp|invoke_entrance',
        support: '2.4.4',
        prepare: function () {
            return ['share_slide_up', {}, noop];
        }
    },
    hideEntrance: {
        // name: 'hide_entrance',
        alias: 'hide_entrance',
        support: [{ type: 'android', version: '2.4.4' }],
        prepare: function (params, cb) {
            return ['hide_entrance', params, cb];
        }
    },
    showEntrance: {
        alias: 'show_entrance',
        support: [{ type: 'android', version: '2.4.4' }],
        prepare: function (params, cb) {
            return ['show_entrance', params, cb];
        }
    },
    startCarRequest: {
        alias: 'driverOut|driver_out',
        support: '2.4.5',
        prepare: function (params, cb) {
            var fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['driver_out', {}, fn];
        }
    },
    toHomePage: {
        alias: 'toMainPage',
        support: '2.4.4',
        prepare: function (params, cb) {
            return ['toMainPage', params, cb];
        }
    },
    closePage: {
        // name: 'page_close',
        alias: 'page_close|pageClose',
        support: '2.4.5',
        prepare: function (params, cb) {
            return ['page_close', params, cb];
        }
    },
    chooseContact: {
        // name: 'readPhoneContact',
        alias: 'getContact',
        support: [{ type: 'android', version: '2.4.4' }],
        prepare: function (params, cb) {
            return ['readPhoneContact', params, cb];
        }
    },
    photograph: {
        support: '2.4.4'
    },
    chooseImage: {
        support: '3.1.6'
    },
    orderDetailInfo: {
        support: '2.4.4'
    },
    orderReassignState: {
        support: [{ type: 'ios', version: '2.4.4' }]
    },
    checkOrderDetail: {
        support: '2.4.4'
    },
    orderTripEnd: {
        support: '5.1.34',
        prepare: function (params, cb) {
            var fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['orderTripEnd', params, fn];
        }
    },
    getUserInfo: {
        support: '2.4.5',
        prepare: function (params, cb) {
            var BRIDGE_TIMEOUT = 2000;
            var fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                var data = {
                    phone: result.phone,
                    ticket: result.ticket
                };
                cb(data);
            };
            // 300ms内没有返回就callback
            var wrappedFn = onceIn(fn, BRIDGE_TIMEOUT);
            return ['getUserInfo', {}, wrappedFn];
        }
    },
    getSystemInfo: {
        support: '3.1.6',
        prepare: function (params, cb) {
            var fn = function (result) {
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                result.a3 = result.a3 || result.a3_token || '';
                result.deviceid = result.deviceid || '';
                result.vcode = result.vcode || '';
                result.os = result.os || '';
                cb(result);
            };
            // android native从5.1.0起开始支持getSystemInfo方法
            if (Env.isAndroidApp && compareVersion('<5.1.0')) {
                handle('getDeviceMarkInfo', {}, function (res) {
                    // 下面使 android getDeviceMarkInfo 与 ios getSystemInfo 返回参数对齐
                    res.a3 = res.a3 || res.a3_token || '';
                    res.deviceid = res.deviceid || '';
                    res.vcode = res.vcode || '';
                    res.os = res.os || '';
                    cb(res);
                });
            }
            else {
                return ['getSystemInfo', {}, fn];
            }
        }
    },
    getDeviceMarkInfo: {
        support: '2.7.0'
    },
    getLocationInfo: {
        support: '2.4.4',
        prepare: function (params, cb) {
            var fn = function (result) {
                var r = {};
                // iOS返回的是字符串
                result =
                    typeof result === 'string' ? JSON.parse(result) : result;
                if (support('getHydraData')) {
                    // android & ios 从getHydraData(>2.6.0)方法中取Cityid
                    handle('getHydraData', {}, function (res) {
                        res = typeof res === 'string' ? JSON.parse(res) : res;
                        // android返回a3_token，iOS返回a3
                        r.lng = result.lng || '';
                        r.lat = result.lat || '';
                        // getLocationInfo IOS返回的city_id不可靠（不知道对不对），使用getHydraData返回的Cityid作为返回给h5的值
                        r.cityId = res.Cityid || '';
                        r.area = result.area || '';
                        cb(r);
                    });
                }
                else {
                    r.lng = result.lng || '';
                    r.lat = result.lat || '';
                    r.cityId = result.city_id || '';
                    r.area = result.area || '';
                    cb(r);
                }
            };
            return ['getLocationInfo', {}, fn];
        }
    },
    launchNav: {
        support: '2.4.4'
    },
    addCornerButton: {
        support: '2.5.2',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
            }
            else if (Env.isAndroidApp) {
                window[jsCall] = cb;
            }
            return ['addCornerButton', params, noop];
        }
    },
    resetBack: {
        support: '2.6.0'
    },
    getHydraData: {
        support: '2.6.0',
        prepare: function (params, cb) {
            var fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['getHydraData', {}, fn];
        }
    },
    requestLogout: {
        alias: 'exitLogin',
        support: '3.1.6',
        prepare: function (params, cb) {
            return ['exitLogin', params, cb];
        }
    },
    openPage: {
        support: '2.7.4'
    },
    wxPayRequest: {
        support: '3.0.2'
    },
    open19PayPage: {
        support: '5.1.26',
        prepare: function (params, cb) {
            var fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['open19PayPage', params, fn];
        }
    },
    commonPay: {
        support: '3.0.2',
        prepare: function (params, cb) {
            var fn = function (result) {
                var ret;
                if (typeof result === 'string') {
                    ret = JSON.parse(result);
                }
                else {
                    ret = result;
                }
                cb(ret);
            };
            if (params.type === 'weixin') {
                return ['wxPayRequest', params.pay_params, fn];
            }
            else if (params.type === 'ali') {
                return ['aliPayRequest', { pay_string: params.pay_params }, fn];
            }
        }
    },
    viewIsBackground: {
        support: '5.0.22',
        prepare: function (params, cb) {
            // ios 无法保存回调函数，通过registerHandler注册一个函数来保存
            if (Env.isIOSApp) {
                var jsCall_1 = 'viewIsBackground' + new Date().getTime();
                params.jsCallback = jsCall_1;
                var fn_1 = function (result) {
                    if (typeof result === 'string') {
                        var ret = JSON.parse(result);
                        cb(ret);
                    }
                };
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall_1, fn_1);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall_1, fn_1);
                    });
                }
                return ['viewIsBackground', params, noop];
            }
            else if (Env.isAndroidApp) {
                return ['viewIsBackground', params, cb];
            }
        }
    },
    setTitle: {
        alias: 'controllerTitle',
        support: [
            { type: 'ios', version: '5.0.0' },
            { type: 'android', version: '5.0.0' }
        ],
        prepare: function (params, cb) {
            var vctitle = params.vctitle;
            document.title = vctitle;
            return ['controllerTitle', params, cb];
        }
    },
    launchIm: {
        support: '5.0.30'
    },
    showImEntrance: {
        support: '5.0.30'
    },
    faceRecognize: {
        support: '5.0.30',
        prepare: function (params, cb) {
            var fn = function (res) {
                if (typeof res === 'string') {
                    res = JSON.parse(res);
                }
                cb(res);
            };
            return ['faceRecognize', params, fn];
        }
    },
    controlBackPress: {
        support: '5.0.28',
        prepare: function (params, cb) {
            if (Env.isAndroidApp || Env.isHonghu) {
                if (params.type === 'request') {
                    return ['requestBackPressedControl', params, cb];
                }
                else if (params.type === 'cancel') {
                    return ['cancelBackPressedControl', params, cb];
                }
            }
            else if (Env.isIOSApp) {
                var jsCall_2 = 'controlBackPress' + new Date().getTime();
                params.jsCallback = jsCall_2;
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall_2, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall_2, cb);
                    });
                }
                return ['controlBackPress', params, noop];
            }
        }
    },
    resizeImage: {
        support: [{ type: 'android', version: '2.4.4' }]
    },
    getA3Token: {
        support: '5.0.0',
        prepare: function (params, cb) {
            var fn = function (result) {
                var r = {};
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                if (support('getSystemInfo')) {
                    // iOS只能从getSystemInfo方法中取imei
                    handle('getSystemInfo', {}, function (res) {
                        // iOS返回string
                        if (typeof res === 'string') {
                            res = JSON.parse(res);
                        }
                        r = {
                            a3: result.a3_token || result.a3 || '',
                            imei: res.imei || ''
                        };
                        cb(r);
                    });
                }
                else {
                    r = {
                        a3: result.a3_token || result.a3 || '',
                        imei: result.imei || ''
                    };
                    cb(r);
                }
            };
            return ['getDeviceMarkInfo', {}, fn];
        }
    },
    shareFacebook: {
        support: '5.0.20',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params;
            return ['shareFacebook', params, cb];
        }
    },
    shareLine: {
        support: '5.0.20',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params;
            return ['shareLine', params, noop];
        }
    },
    shareWhatsApp: {
        support: '5.0.20',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params;
            return ['shareWhatsApp', params, noop];
        }
    },
    shareTwitter: {
        support: '5.0.20',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params;
            return ['shareTwitter', params, noop];
        }
    },
    shareEmail: {
        support: '5.0.20',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params;
            return ['shareEmail', params, noop];
        }
    },
    shareFBMessenger: {
        support: '5.0.20',
        prepare: function (params, cb) {
            params = Env.isIOSApp ? JSON.stringify(params) : params;
            return ['shareFBMessenger', params, noop];
        }
    },
    startRecord: {
        support: '5.0.0',
        prepare: function (params) {
            var voiceLocalFinish = params.voiceLocalFinish, voiceUploadFinish = params.voiceUploadFinish, rest = __rest(params, ["voiceLocalFinish", "voiceUploadFinish"]);
            if (Env.isIOSApp) {
                window.DidiJSBridge.registerHandler('voiceLocalFinish', voiceLocalFinish);
                window.DidiJSBridge.registerHandler('voiceUploadFinish', voiceUploadFinish);
            }
            else if (Env.isAndroidApp) {
                window.didi = window.didi || {};
                window.didi.bridge = window.didi.bridge || {};
                window.didi.bridge._callback = function (data) {
                    var result = {};
                    try {
                        result = JSON.parse(data.data);
                    }
                    catch (e) { }
                    if (data && data.handlerName === 'voiceLocalFinish') {
                        voiceLocalFinish(result);
                    }
                    else if (data &&
                        data.handlerName === 'voiceUploadFinish') {
                        voiceUploadFinish(result);
                    }
                };
            }
            else {
                throw new Error('Bridge error: This page is not in a driver.');
            }
            return ['startRecord', rest, noop];
        }
    },
    callPassengerPhone: {
        support: '5.0.10',
        prepare: function (params, cb) {
            var hasExecuted = false;
            var flag = false;
            var fn = function (result) {
                flag = true;
                if (hasExecuted)
                    return;
                hasExecuted = true;
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            // 200ms内没有返回正常结果，则返回{}
            if (Env.isApp) {
                setTimeout(function () {
                    if (!flag) {
                        var data = {};
                        cb(data);
                    }
                }, 2000);
            }
            return ['callPassengerPhone', params, fn];
        }
    },
    doInterceptVerify: {
        support: '5.0.10',
        prepare: function (params, cb) {
            var hasExecuted = false;
            var flag = false;
            var fn = function (result) {
                flag = true;
                if (hasExecuted)
                    return;
                hasExecuted = true;
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            // 200ms内没有返回正常结果，则返回{}
            if (Env.isApp) {
                setTimeout(function () {
                    if (!flag) {
                        var data = {};
                        cb(data);
                    }
                }, 5000);
            }
            return ['doInterceptVerify', params, fn];
        }
    },
    endRecord: {
        support: '5.0.0'
    },
    playVoice: {
        support: '5.0.0'
    },
    stopVoice: {
        support: '5.0.0'
    },
    addFee: {
        support: '5.1.10'
    },
    confirmProtocol: {
        support: '5.1.10'
    },
    checkRecordPermis: {
        support: '5.1.10'
    },
    requestRecordPermis: {
        support: '5.1.10'
    },
    openPermisSettingPage: {
        support: '5.1.10'
    },
    closeCarRequest: {
        support: '5.1.10',
        prepare: function (params, cb) {
            var fn = function (result) {
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['closeCarRequest', params, fn];
        }
    },
    statisticsPageLoadTime: {
        support: '5.1.20',
        prepare: function (params, cb) {
            return ['statisticsPageLoadTime', params, cb];
        }
    },
    unioneOrderOfflinePay: {
        support: '5.1.42',
        prepare: function (params, cb) {
            var fn = function (result) {
                var ret = typeof result === 'string' ? JSON.parse(result) : result;
                cb(ret);
            };
            return ['unioneOrderOfflinePay', params, fn];
        }
    },
    showCommendRobot: {
        support: '5.2.0',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
            }
            else if (Env.isAndroidApp) {
                window[jsCall] = cb;
            }
            return ['showCommendRobot', params, cb];
        }
    },
    onPageStop: {
        support: '5.2.0',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
            }
            else if (Env.isAndroidApp) {
                window[jsCall] = cb;
            }
            return ['onPageStop', params, cb];
        }
    },
    callUpVoIP: {
        support: [
            { type: 'ios', version: '5.3.0' },
            { type: 'android', version: '5.3.4' }
        ],
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
                return ['callUpVoIP', params, noop];
            }
            // else if (Env.isAndroidApp) {
            //     return ['callUpVoIP', params, cb]
            // }
            return ['callUpVoIP', params, cb];
        }
    },
    davCaptureVideo: {
        support: '5.3.4',
        prepare: function (params, cb) {
            var fn = function (result) {
                var ret = Array.isArray(result) ? result[0] : result;
                cb(ret);
            };
            return ['davCaptureVideo', params, fn];
        }
    },
    davPlayVideo: {
        support: '5.3.4',
        prepare: function (params, cb) {
            var fn = function (result) {
                var ret = Array.isArray(result) ? result[0] : result;
                cb(ret);
            };
            return ['davPlayVideo', params, fn];
        }
    },
    wechatCardAuthAction: {
        support: '5.3.8',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
            }
            else if (Env.isAndroidApp) {
                window[jsCall] = cb;
            }
            return ['wechatCardAuthAction', params, cb];
        }
    },
    getCurrentOrderStatus: {
        support: '5.3.10',
        prepare: function (params, cb) {
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
            }
            else if (Env.isAndroidApp) {
                window[jsCall] = cb;
            }
            return ['getCurrentOrderStatus', params, cb];
        }
    },
    saveImage: {
        support: '5.3.10',
        prepare: function (params, cb) {
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
            }
            else if (Env.isAndroidApp) {
                window[jsCall] = cb;
            }
            return ['saveImage', params, cb];
        }
    },
    requestCameraPermission: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('requestCameraPermissionCb', cb);
            return ['requestCameraPermission', params, cb];
        }
    },
    requestRecordPermission: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('requestRecordPermissionCb', cb);
            return ['requestRecordPermission', params, cb];
        }
    },
    playTts: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('playTtsCb', cb);
            return ['playTts', params, cb];
        }
    },
    stopTts: {
        support: '5.4.2'
    },
    videoInterviewPart: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('videoInterviewPartCb', cb);
            return ['videoInterviewPart', params, cb];
        }
    },
    bodyTest: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('bodyTestCb', cb);
            return ['bodyTest', params, cb];
        }
    },
    startInterview: {
        support: '5.4.2'
    },
    travelShare: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('travelShareCb', cb);
            return ['travelShare', params, cb];
        }
    },
    oneAlarm: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('oneAlarmCb', cb);
            return ['oneAlarm', params, cb];
        }
    },
    trackEvent: {
        support: '5.3.0',
        prepare: function (params, cb) {
            var key = params.key, eventLabel = params.eventLabel, attrs = params.attrs;
            var solvedParams = {
                evenId: key
            };
            if (eventLabel || attrs) {
                Object.assign(solvedParams, {
                    params: eventLabel || attrs
                });
            }
            return ['trackEvent', JSON.stringify(solvedParams), noop];
        }
    },
    startGuideRecognize: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('startGuideRecognizeCb', cb);
            return ['startGuideRecognize', params, cb];
        }
    },
    cancelGuideRecognize: {
        support: '5.4.2',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('cancelGuideRecognizeCb', cb);
            return ['cancelGuideRecognize', params, cb];
        }
    },
    navigationShowOrHide: {
        support: '6.0.0',
        prepare: function (params, cb) {
            params.jsCallback = registerJsHandler('navigationShowOrHideCb', cb);
            return ['navigationShowOrHide', params, cb];
        }
    },
    getWsgInfo: {
        support: '6.0.2',
        prepare: function (params, cb) {
            var fn = function (result) {
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['getWsgInfo', params, fn];
        }
    },
    screenshot: {
        support: '6.0.4',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
            }
            else if (Env.isAndroidApp) {
                window[jsCall] = cb;
            }
            return ['screenshot', params, cb];
        }
    },
    takeAIImage: {
        support: '6.1.14',
        prepare: function (params, cb) {
            var fn = function (result) {
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['takeAIImage', params, fn];
        }
    },
    getOnlineStatus: {
        support: '6.1.13',
        prepare: function (params, cb) {
            var fn = function (result) {
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['getOnlineStatus', params, fn];
        }
    },
    showPrivacy: {
        support: '6.1.13',
        prepare: function (params, cb) {
            var fn = function (result) {
                if (typeof result === 'string') {
                    result = JSON.parse(result);
                }
                cb(result);
            };
            return ['showPrivacy', params, fn];
        }
    },
    requireLocationPermisstion: {
        support: [
            { type: 'android', version: '6.1.6' },
            { type: 'ios', version: '6.1.13' }
        ]
    },
    requestLogin: {
        support: '8.0.0'
    },
    openSingleMessage: {
        support: '8.0.0'
    },
    openGroupMessage: {
        support: '8.0.0'
    },
    openVoip: {
        support: '8.0.0'
    },
    openScanCode: {
        support: '8.0.0'
    },
    sendMessage: {
        support: '8.0.0'
    },
    backToHome: {
        support: '8.0.0',
        prepare: function (params, cb) {
            // 重置回调名，避免覆盖的可能
            var jsCall = '' + params.jsCallback + new Date().getTime();
            params.jsCallback = jsCall;
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.registerHandler(jsCall, cb);
                }
                else {
                    document.addEventListener('DidiJSBridgeReady', function () {
                        window.DidiJSBridge.registerHandler(jsCall, cb);
                    });
                }
            }
            else if (Env.isAndroidApp) {
                window[jsCall] = cb;
            }
            return ['backToHome', params, function () { }];
        }
    },
    share: {
        support: '8.0.0'
    },
    // 部落底导「全部功能」页面里应用入口点击
    functionItemClick: {
        support: '8.0.0'
    }
};
export default config;
